import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  // These will be loaded from environment variables
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'europe-west3');
export const storage = getStorage(app);

// Connect to emulators in development
if (import.meta.env.DEV || window.location.hostname === 'localhost') {
  console.log('🔧 Using production Firebase services...');
  
  // Connect Functions to emulator - COMMENTED OUT to use production
  // connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  // console.log('✅ Functions emulator connected');
  
  // Connect Storage to emulator - COMMENTED OUT to use production
  // connectStorageEmulator(storage, '127.0.0.1', 9199);
  // console.log('✅ Storage emulator connected');
  
  // Uncomment if you want to use Firestore emulator
  // connectFirestoreEmulator(db, '127.0.0.1', 8080);
  // console.log('✅ Firestore emulator connected');
  
  // Uncomment if you want to use Auth emulator
  // connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  // console.log('✅ Auth emulator connected');
}

export default app;
